import { brandLogoUrl } from './brandLogoUrl';
import type { BrandFile } from '@hub/common';

/** Requests the brand's logo at low priority. A plain image request without
 *  `crossOrigin`, so an `<img>` with the same address reads it from the
 *  browser cache. */
export const preloadBrandLogo = (file: BrandFile | null | undefined): void => {
  const url = brandLogoUrl(file);
  if (!url) return;
  const image = new Image();
  image.fetchPriority = 'low';
  image.src = url;
};
